import { useCallback, useEffect, useMemo, useState } from 'react';

export function usePWAInstall() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    const onBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    const onAppInstalled = () => {
      setIsInstalled(true);
      setDeferredPrompt(null);
    };

    window.addEventListener('beforeinstallprompt', onBeforeInstallPrompt);
    window.addEventListener('appinstalled', onAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstallPrompt);
      window.removeEventListener('appinstalled', onAppInstalled);
    };
  }, []);

  const isIOS = useMemo(() => {
    const ua = window.navigator.userAgent || '';
    const iOS = /iPad|iPhone|iPod/.test(ua);
    const isSafari = /Safari/.test(ua) && !/Chrome|CriOS|FxiOS|EdgiOS/.test(ua);
    return iOS && isSafari;
  }, []);

  const isStandalone = useMemo(() => {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  }, []);

  const isInstallable = !!deferredPrompt && !isStandalone && !isInstalled;

  const promptInstall = useCallback(async () => {
    if (!deferredPrompt) return { outcome: 'dismissed' };
    try {
      deferredPrompt.prompt();
      const choice = await deferredPrompt.userChoice;
      setDeferredPrompt(null);
      return choice;
    } catch (e) {
      return { outcome: 'dismissed' };
    }
  }, [deferredPrompt]);

  return {
    isIOS,
    isStandalone,
    isInstallable,
    promptInstall
  };
}
